// Module
var code = "<div class=\"content-library-content-grid-with-filters\"> <content-library-content-grid filters=\"$ctrl.filters\" view-mode=\"$ctrl.viewMode\" ready=\"$ctrl.ready\" detail-link-clicked=\"$ctrl.detailLinkClicked()\" scroll-container=\"::$ctrl.scrollContainer\" collection-id=\"::$ctrl.collectionId\"> </content-library-content-grid> </div> ";
// Exports
module.exports = code;